export const END_POINT = {
  USER: {
    GET_USER_INFO: 'api/v1/members/me',
    GET_USER_STATUS: 'api/v1/members/me/status',
    GET_USER_COMPLETION: 'api/v1/members/completion',
    GET_MY_PAGE_INFO: 'api/v1/members/mypage',
  },
};
